import CommonModal from "../../components/Modals/CommonModal";
import Style from "./ImageCrop.module.scss";
import Assets from "../../components/Layouts/Assets";
import { Slider } from "antd";
import FileDropSection from "./FileDropSection";
import Footer from "./Footer";
import { useCrop } from "./useCrop";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const ImageCrop = ({ open, close, title, type, stepsData, setStepsData }) => {
  const {
    imgRef,
    tempRef,
    crop,
    selectedImage,
    error,
    isLoading,
    tempImage,
    setCrop,
    setSelectedImage,
    handleDragOver,
    handleDragOut,
    handleDrop,
    handleImageChange,
    handleSave,
    RemoveImage,
    handleChangeOpacity,
    handleCancelCrop,
    onLoadImage,
  } = useCrop({ stepsData, setStepsData, type, close, open });

  return (
    <CommonModal
      backdrop="static"
      keyboard={false}
      showModal={open}
      setShowModal={() => {
        setCrop({ aspect: 16 / 9 });
        close();
      }}
      centered={true}
      className={`${Style.MiniFileUploadModal}`}
      title={<h4>{title}</h4>}
      setSelectedImage={setSelectedImage}
      content={
        <>
          <div className={Style.MiniFileUploadModal__contents}>
            {selectedImage ? (
              <>
                <div className={Style.ReactCrop_wrap}>
                  <ReactCrop
                    crop={crop}
                    onChange={(c) => setCrop(c)}
                    // aspect={1 / 1}
                    className="react-crop"
                    // crossorigin="anonymous"
                  >
                    <img
                      src={selectedImage}
                      ref={imgRef}
                      crossOrigin={"anonymous"}
                      onLoad={onLoadImage}
                    />
                    <img src={tempImage} ref={tempRef} className={Style.temp} />
                  </ReactCrop>
                </div>
                {type == "waterMark" && (
                  <>
                    <span className={Style.MiniFileUploadModal_opacity_label}>
                      Opacity
                    </span>

                    <Slider
                      defaultValue={100}
                      disabled={false}
                      min={0}
                      max={100}
                      onChange={(value) => {
                        handleChangeOpacity(value);
                      }}
                    />
                  </>
                )}
              </>
            ) : (
              <FileDropSection
                handleDragOver={handleDragOver}
                handleDrop={handleDrop}
                handleDragOut={handleDragOut}
                error={error}
                type={type}
                handleImageChange={handleImageChange}
              />
            )}
            <p className={Style.MiniFileUploadModal__uploadFileLimit}></p>
          </div>
          <Footer
            close={handleCancelCrop}
            image={selectedImage}
            save={handleSave}
            Remove={RemoveImage}
            isLoading={isLoading}
          />
        </>
      }
    />
  );
};

export default ImageCrop;
